module.exports = __webpack_public_path__ + "img/mascot-print-page.53e7cdfb.png";